import { motion } from "framer-motion";
import { Shield, Mail } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function Footer() {
  return (
    <>
      {/* Closing CTA */}
      <section className="relative px-6 md:px-12 pb-10" data-testid="conclusion-section">
        <div className="max-w-7xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="relative overflow-hidden rounded-[2rem] border border-norton-yellow/20 bg-card p-10 sm:p-16 text-center grain-overlay"
          >
            <div className="absolute top-0 left-1/2 -translate-x-1/2 h-64 w-64 rounded-full bg-norton-yellow/20 blur-[100px]" />
            <div className="relative z-10">
              <span className="text-xs font-bold uppercase tracking-[0.2em] text-norton-yellow">
                🎯 Conclusion
              </span>
              <h2 className="text-3xl sm:text-5xl lg:text-6xl font-heading font-semibold tracking-tighter mt-5 leading-[1.05] max-w-3xl mx-auto">
                Vous vendez une fois,
                <br />
                <span className="text-norton-yellow">Norton gère le reste.</span>
              </h2>
              <p className="text-zinc-400 mt-6 text-lg max-w-2xl mx-auto leading-relaxed">
                Transformez chaque client en source de revenus passifs sur 4 ans, grâce à
                un système de renouvellement automatisé et une commission de 25 % sur les années 2 à 4.
              </p>
              <Button
                asChild
                data-testid="footer-cta-button"
                className="group mt-10 bg-norton-yellow text-black hover:bg-norton-yellow-hover rounded-full text-base font-semibold px-8 h-14 glow-yellow"
              >
                <a href="mailto:contact@antivirusedition.com">
                  <Mail className="mr-2 h-5 w-5" />
                  contact@antivirusedition.com
                </a>
              </Button>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Footer */}
      <footer className="px-6 md:px-12 py-16 border-t border-white/5 mt-10" data-testid="site-footer">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-start md:items-center justify-between gap-8">
          <div className="flex items-center gap-2.5">
            <Shield className="h-7 w-7 text-norton-yellow shrink-0" strokeWidth={2.5} />
            <span className="leading-tight">
              <span className="block text-xl sm:text-2xl font-heading font-bold tracking-tight">
                Antivirus<span className="text-norton-yellow">Edition</span>.com
              </span>
              <span className="block text-xs text-zinc-400 font-body tracking-wide">
                votre distributeur Norton
              </span>
            </span>
          </div>

          <nav className="flex flex-wrap gap-x-8 gap-y-3">
            {[
              { label: "Le programme", href: "#timeline" },
              { label: "Avantages", href: "#benefits" },
              { label: "Simulateur", href: "#simulator" },
              { label: "FAQ", href: "#faq" },
            ].map((l) => (
              <a key={l.href} href={l.href} className="text-sm text-zinc-400 hover:text-norton-yellow transition-colors">
                {l.label}
              </a>
            ))}
          </nav>
        </div>
        <div className="max-w-7xl mx-auto mt-10 pt-8 border-t border-white/5">
          <p className="text-xs text-zinc-600">
            © {new Date().getFullYear()} Norton Empower — Programme Revendeur. Norton est une marque déposée. Les estimations de revenus sont fournies à titre indicatif.
          </p>
        </div>
      </footer>
    </>
  );
}
